import React, { useCallback, useContext, useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { Checkbox } from 'ui-components/components/checkbox';

import { MessageDescriptorPropType } from '../../../../../../../prop-types/intl';
import { ReportsContext } from '../../../context';
import style from './style.module.less';

const FilterCheckbox = ({ props: { apiKey, text } }) => {
  const { setReportParams } = useContext(ReportsContext);
  const [checked, setChecked] = useState(false);

  // oxlint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setReportParams({ apiKey, value: checked }), []);

  const onChange = useCallback(() => {
    setChecked(!checked);
    setReportParams({ apiKey, value: !checked });
  }, [apiKey, checked, setChecked, setReportParams]);

  return <Checkbox checked={checked} className={style['filter-checkbox']} label={text} onChange={onChange} />;
};

FilterCheckbox.propTypes = {
  props: PropTypes.shape({
    apiKey: PropTypes.string,
    text: MessageDescriptorPropType,
  }).isRequired,
};

export default FilterCheckbox;
